import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../contexts';
import { useAggregatedState } from '../../../helpers';

export const HomeContext = React.createContext(null);

const { Provider } = HomeContext;
export const HomeProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({});

    return (
        <Provider value={{
        }}>
            {props.children}
        </Provider>
    );
}